export type PossibleObject = Record<string, unknown> | undefined;
